import { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import validator from 'validator'

import { Grid, Typography, FormControl, TextField, FormHelperText, Button, useMediaQuery } from '@material-ui/core' // Srini 07-01-25
import { withStyles } from '@material-ui/core/styles'
import styles from './loginFormStyles'

import { apiUrl } from '../../ui-utils/apiConfig'
import { httpRequest, updateToken } from '../../ui-utils/api'
import snackError from '../../helpers/snackError'
import { reducerContext } from "../../contextApi's/contextApi's"
import axios from 'axios'

const LoginPage = ({ classes }) => {

    const navigate = useNavigate()
    const isSmallScreen = useMediaQuery('(max-width: 600px)') // Srini 07-01-25

    const { state, dispatch } = useContext(reducerContext)
    const { errorMsg } = state

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [errType, setErrType] = useState(0)

    const agentLoginForm = async () => {

        if (!email.length) {
            setErrType(1)
            dispatch({ type: 'SET_ERROR', payload: 'Enter the Email' })
            return
        }

        if (!validator.isEmail(email)) {
            setErrType(1)
            dispatch({ type: 'SET_ERROR', payload: 'E-Mail is Not Valid' })
            return
        }

        if (!password.length) {
            setErrType(2)
            dispatch({ type: 'SET_ERROR', payload: 'Enter the password' })
            return
        }
        const usernameFromEmail = email.split('@')[0].toLowerCase()
        
        // updated by srini on 20-01-25
        if (isSmallScreen && !['muneer', 'nitesh', 'subbu', 'vshetty', 'ashwini', 'vignesh', 'kamlesh', 'ravi', 'admin'].includes(usernameFromEmail)) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'You are not allowed to log in on small screen devices. Please try logging in on a laptop or desktop.' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            return
        }

        try {
            const agentInfo = { email, secret: password }
            // const openAccount = await axios.post(`http://localhost:5000/api/login/authenticate`, agentInfo)
            const openAccount = await httpRequest({
                endPoint: `${apiUrl.authenticate}`,
                method: "post",
                instance: "instanceOne",
                requestBody: agentInfo,

            })

            console.log("openAccount", openAccount)

            if (openAccount?.status  === 200) {
                console.log("hello")
                const token = openAccount?.data?.token
                const user_data=openAccount?.data?.user_data

                localStorage.setItem('sipRegData', JSON.stringify(user_data))

                localStorage.setItem('token',token)
                localStorage.setItem('email', user_data.email)
                localStorage.setItem('username', user_data.name)
                localStorage.setItem('departmentName', user_data?.departments?.[0].name)
                localStorage.setItem('roleName', user_data?.roles?.[0].name) // srini - 31/12/24

                dispatch({ type: 'USER_SIGN_IN', payload: true })
                dispatch({
                    type: 'SET_SHOW_ERROR',
                    payload: true
                })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })
                dispatch({ type: 'SET_TOKEN_VAL', payload: 'Valid' })
                dispatch({ type: 'SET_ERROR', payload: "Registered" })
                navigate('/incomplete-kyc')
                // dispatch({ type: 'USER_SIGN_IN', payload: true })
                // dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })
                // dispatch({
                //     type: 'SET_SHOW_ERROR',
                //     payload: true
                // })
               
                // dispatch({ type: 'SET_TOKEN_VAL', payload: 'Valid' })

                // localStorage.setItem('JANUS_PROXY_URL', user_data.FS_WS_PROXY_URL_INT)  // no more JANUS keys available in authentication responce - srini - 31-01-25
                // localStorage.setItem('FS_IMPI', user_data.FS_IMPI)
                // localStorage.setItem('FS_IMPU', user_data.FS_IMPU)
                // localStorage.setItem('FS_WS_PROXY_URL_INT', user_data.FS_WS_PROXY_URL_INT)
                // localStorage.setItem('FS_WS_PROXY_URL_EXT', user_data.FS_WS_PROXY_URL_EXT)
                // localStorage.setItem('FS_REALM', user_data.FS_REALM)
                // localStorage.setItem('FS_SECRET', user_data.FS_SECRET)

                // const aid = user_data.FS_IMPI	 // no more JANUS_USERNAME.split("@")[0].split(":")[1] - srini - 31-01-25
                // localStorage.setItem('user_id1', aid)
                // localStorage.setItem('agentRole', JSON.stringify(user_data.user_roles)) // srini - 31/12/24
                // localStorage.setItem('agentMenu', JSON.stringify(user_data.user_menus)) // Srini - 05/12/24

                // updateToken()

                

                // const departmentName = await axios.get(`http://localhost:5000/api/user/email/${user_data?.email}`)
                // console.log('departmentName',departmentName.data?.data?.data)
                // const depData = departmentName.data?.data?.data

                // if (!departmentName?.data.status == 200) {
                //     console.log('Error in Authenticate API', departmentName)
                // }

               
                // // Srini 07-01-25
                // if (isSmallScreen && departmentName.data[0].departments[0].name === 'Franchisee') {
                //     navigate('/franchiseDashboard')
                // } else {
                //     navigate('/incomplete-kyc')
                // }

            }
            // login expection shows -25/09/24 - dev Srini
            else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: openAccount?.data?.msg })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log('Error in Authenticate API', openAccount)
            }

        }
        catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Error occured while authentication.' }) // try failed because of some API error. not connected to user
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log('Error in Authenticate API', error)
        }
    }

    return (
        <div className={classes.loginCard} >

            <Typography className={classes.loginHeading} > Login </Typography>

            <Grid container spacing={4} style={{ padding: isSmallScreen? '10px 40px' : '20px 50px' }} >

                <Grid item xs={12}>

                    <FormControl>
                        <TextField
                            placeholder="Email"
                            InputProps={{
                                style: {
                                    width: isSmallScreen ? '60vw' : '400px', // Srini 07-01-25
                                    height: '48px',
                                    flexShrink: 0,
                                    borderRadius: '8px ',
                                    border: '1px solid #999 ',
                                    background: 'var(--b, #FFF)',
                                    fontFamily: 'cardiuma-regular',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: '20px',
                                    padding: '3%'
                                }
                            }}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {errType === 1 &&
                            <FormHelperText className={classes.errTxt} id="component-error-text">{errorMsg}</FormHelperText>
                        }
                    </FormControl>
                </Grid>

                <Grid item xs={12}>

                    <FormControl>
                        <TextField
                            type="password"
                            placeholder="Password"
                            InputProps={{
                                style: {
                                    width: isSmallScreen ? '60vw' : '400px', // Srini 07-01-25
                                    height: '48px',
                                    flexShrink: 0,
                                    borderRadius: '8px ',
                                    border: '1px solid #999 ',
                                    background: 'var(--b, #FFF)',
                                    fontFamily: 'cardiuma-regular',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: '20px',
                                    padding: '3%'
                                }
                            }}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        {errType === 2 &&
                            <FormHelperText className={classes.errTxt} id="component-error-text">{errorMsg}</FormHelperText>
                        }
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <Button className={classes.buttonCard} onClick={agentLoginForm}>
                        <span className={classes.buttonText} style={{ textTransform: 'none' }}> Login</span>
                    </Button>
                </Grid>

            </Grid>
        </div>
    )
}

export default withStyles(styles)(LoginPage)